"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeECON = function CategoryCodeECON(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeECON"), _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M5.6,7.058a1.235,1.235,0,0,0-.117-.274.982.982,0,0,0-.2-.235,2.128,2.128,0,0,0-.221-.171,1.984,1.984,0,0,0-.269-.147c-.109-.051-.2-.091-.262-.117s-.156-.059-.276-.1l-.232-.088c-.051-.02-.117-.049-.2-.086a1.1,1.1,0,0,1-.17-.09,1.5,1.5,0,0,1-.122-.1.264.264,0,0,1-.069-.092.308.308,0,0,1-.02-.113.3.3,0,0,1,.152-.264.788.788,0,0,1,.455-.119,1.07,1.07,0,0,1,.259.033,1.456,1.456,0,0,1,.232.078,1.781,1.781,0,0,1,.184.1c.057.035.1.062.122.08l.038.03.011.009a.224.224,0,0,0,.176.045.207.207,0,0,0,.163-.109L5.5,4.853a.209.209,0,0,0-.035-.269c-.015-.014-.033-.031-.056-.05a1.455,1.455,0,0,0-.142-.1A1.6,1.6,0,0,0,5.042,4.3a2.357,2.357,0,0,0-.308-.115,2,2,0,0,0-.29-.066V3.651a.217.217,0,0,0-.066-.159A.226.226,0,0,0,4.22,3.43H3.765a.219.219,0,0,0-.156.064.216.216,0,0,0-.068.157v.49a1.649,1.649,0,0,0-.825.449,1.207,1.207,0,0,0-.363.867,1.222,1.222,0,0,0,.032.281,1.307,1.307,0,0,0,.077.236A.9.9,0,0,0,2.6,6.19a2.037,2.037,0,0,0,.155.168,1.289,1.289,0,0,0,.2.153c.076.049.142.089.2.119s.13.067.22.106.16.068.212.088l.207.081c.12.045.208.079.265.1s.129.058.216.1a.79.79,0,0,1,.172.1.539.539,0,0,1,.091.11.208.208,0,0,1,.033.111.335.335,0,0,1-.156.3.716.716,0,0,1-.415.12,1.116,1.116,0,0,1-.227-.024A1.672,1.672,0,0,1,3,7.451a.2.2,0,0,0-.177-.062.212.212,0,0,0-.155.082l-.347.44a.21.21,0,0,0,.01.28c.013.015.036.038.068.068a2.122,2.122,0,0,0,.167.131,2.385,2.385,0,0,0,.262.164,2.422,2.422,0,0,0,.36.152,2.276,2.276,0,0,0,.35.091v.468a.213.213,0,0,0,.068.157.219.219,0,0,0,.156.064H4.22a.226.226,0,0,0,.158-.062.217.217,0,0,0,.066-.159V8.794a1.56,1.56,0,0,0,.839-.461A1.332,1.332,0,0,0,5.649,7.4,1.134,1.134,0,0,0,5.6,7.058Z"
  }), _react.default.createElement("rect", {
    x: "2.478",
    y: "10.447",
    width: "2.968",
    height: "2.207",
    rx: "0.405",
    ry: "0.405"
  }), _react.default.createElement("rect", {
    x: "6.588",
    y: "5.018",
    width: "2.968",
    height: "7.637",
    rx: "0.405",
    ry: "0.405"
  }), _react.default.createElement("rect", {
    x: "10.698",
    y: "2.811",
    width: "2.968",
    height: "9.844",
    rx: "0.405",
    ry: "0.405"
  }))));
};

var _default = CategoryCodeECON;
exports.default = _default;